// Autogenerated from app-config.json
// Do not edit
// MICRO_FRONTEND_DATA_ENTRY_POINT
import socialImports from '@social/configs/app-root-imports.config';
import reviewImports from '@review/configs/app-root-imports.config';

export default [...socialImports,...reviewImports];
// MICRO_FRONTEND_DATA_EXIT_POINT
